import { render, staticRenderFns } from "./inspectionAction.vue?vue&type=template&id=5667fe13"
import script from "./inspectionAction.vue?vue&type=script&lang=js"
export * from "./inspectionAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports